import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: #fff;
	padding: 70px 0;
	width: 100%;
`;

export const HeadingLowerFont = styled.p`
	margin: 0;
	text-align: center;
	font-size: 16px;
	color: #525252;
	padding: 0 16px;
`;

export const HeadingFont = styled.p`
	margin: 0;
	text-align: center;
	line-height: 1.2;
	font-size: 22px;
	font-weight: 900;
	padding: 0 16px;
`;

export const ContentContainer = styled.div`
	width: 55%;
	margin: auto;
	margin-top: 40px;
	@media screen and (max-width: 1400px) {
		width: 95%;
	}
	@media screen and (max-width: 500px) {
		width: 100%;
	}
`;

export const Divider = styled.div`
	width: 100%;
	height: 1px;
	background-color: #d5d5d5;
	margin: 10px 0;
`;

export const FilePickerWrapper = styled.div`
	display: flex;
	flex-flow: column nowrap;
	width: 100%;
	position: relative;
	&::before {
		content: '';
		display: block;
		background-image: linear-gradient(
			#03a4ec 35%,
			rgba(255, 255, 255, 0) 35%
		);
		background-position: right center;
		background-size: 10px 12px;
		background-repeat: repeat-y;
		width: 2px;
		height: calc(
			100% - 160px - 58px - 20px
		); // 100% - dolna część - częśc zakładek
		bottom: 0px;
		position: absolute;
		left: 0px;
		transform: translateY(-160px);
	}
`;

export const PickerTabsContainer = styled.div`
	display: flex;
	flex-flow: row nowrap;
	background: #f0f0f0;
	padding-top: 20px;
	/* ===== Scrollbar CSS ===== */
	/* Firefox */
	& {
		scrollbar-width: auto;
		scrollbar-color: #a3a3a3 transparent;
	}

	/* Chrome, Edge, and Safari */
	&::-webkit-scrollbar {
		height: 5px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
	}

	&::-webkit-scrollbar-thumb {
		background-color: #a3a3a3;
		border-radius: 10px;
	}
	@media screen and (max-width: 600px) {
		overflow-x: auto;
	}
`;

export const PickerContentWrapper = styled.div`
	display: flex;
	flex-flow: column nowrap;
	overflow-y: auto;
	max-height: 630px;
	background-color: #fff;
	padding: 25px;
	@media screen and (max-width: 800px) {
		padding: 10px;
	}
`;

export const PickerTabWrapper = styled.div<{ active: boolean }>`
	font-size: 16px;
	padding: 15px 30px;
	cursor: pointer;
	user-select: none;
	border-bottom: 2px solid #03a4ec;
	${({ active }) =>
		!active &&
		`
        &:hover {
            background-color: #ffffff75;
        }
    `}
	${({ active }) =>
		active &&
		`
        background-color: #fff;
        border: 2px solid #03A4EC;
    	border-bottom: 2px solid #fff;
        font-weight: 900;
    `}
	@media screen and (max-width: 800px) {
		white-space: nowrap;
		padding: 15px;
	}
	@media screen and (max-width: 750px) {
		font-size: 13px;
	}
`;

export const TabBlank = styled.div`
	flex: 1;
	border-bottom: 2px solid #03a4ec;
`;

export const PickerFoot = styled.div`
	height: 160px;
	border-radius: 0 0 20px 20px;
	width: 100%;
	background-image: linear-gradient(
		135deg,
		#dddddd 25%,
		transparent 25%,
		transparent 50%,
		#dddddd 50%,
		#dddddd 75%,
		transparent 75%,
		transparent 100%
	);
	background-size: 8.49px 8.49px;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	&::before {
		content: '';
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 20px;
		background: linear-gradient(rgba(0, 0, 0, 0.09), transparent);
		pointer-events: none;
	}
`;

export const FileItemWrapper = styled.div`
	display: flex;
	flex-flow: row nowrap;
	width: 100%;
	align-items: center;
	min-height: 60px;
	transition: all 150ms linear;
	position: relative;
	cursor: pointer;
	&:hover {
		background-color: #fafafa;
		.title {
			color: #000;
			font-weight: 600;
		}
		.meta {
			color: #757575;
			font-weight: 600;
		}
		.icon__pdf {
			fill: #e59a8f;
		}
		.icon__word {
			fill: #5a63bc;
		}
		.download {
			display: block;
		}
	}
	&:not(:last-child) {
		border-bottom: 1px solid #d4d4d4;
	}
`;

export const FileItemIconContainer = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	svg {
		fill: #d4d4d4;
		width: 35px;
		height: 35px;
		transition: fill 150ms linear;
	}
`;

export const FileItemTitleContainer = styled.div`
	flex: 12;
	display: flex;
	align-items: center;
	p {
		margin: 0;
		color: #161616;
		font-size: 16px;
		transition: color 150ms linear;
	}
	p.title {
		margin-left: 8px;
	}
	@media screen and (max-width: 600px) {
		p {
			font-size: 12px;
		}
	}
`;

export const FileItemDataContainer = styled.div`
	display: flex;
	flex-flow: column nowrap;
	align-items: flex-end;
	margin-right: 40px;
	p {
		margin: 0;
		color: #8f8f8f;
		transition: color 150ms linear;
	}
`;

export const DownloadButton = styled.div`
	display: none;
	position: absolute;
	top: 50%;
	right: 10px;
	transform: translateY(-30%);
	svg {
		fill: #757575;
	}
	@media screen and (max-width: 1100px) {
		display: block;
	}
`;

export const DownloadAllButton = styled.div`
	cursor: pointer;
	user-select: none;
	display: flex;
	position: relative;
	background-color: #fff;
	padding: 15px 45px;
	border: 2px solid #03a4ec;
	border-radius: 10px;
	svg {
		width: 25px;
		height: 25px;
		fill: #03a4ec;
		position: absolute;
		top: 50%;
		left: 12px;
		transform: translateY(-50%);
	}
	p {
		margin: 0;
		font-size: 16px;
		margin-left: 6px;
	}
`;
